import { useEffect, useState, useRef } from "react";

const RAW_URL =
    "https://api.raceresult.com/393212/NSUA9ZJ4CNHTCRRZ4O52AS3CAEAU0GGL";

const INFO_URL =
    "https://api.raceresult.com/393212/8GW8QQP1IKBN1RMH6BIR27INRI997XAN";

// Heure de départ : 10:20:00 = 37200 secondes
const START_TIME = 37200;

// Convertir secondes → hh:mm:ss.mmm
function formatTimestamp(sec) {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = (sec % 60).toFixed(3);
    return `${h.toString().padStart(2,"0")}:${m.toString().padStart(2,"0")}:${s.padStart(6,"0")}`;
}

// Convertir secondes → mm:ss.xx
function formatRaceTime(sec) {
    if (sec < 0) return "—";
    const m = Math.floor(sec / 60);
    const s = (sec % 60).toFixed(2);
    return `${m}:${s.toString().padStart(5,"0")}`;
}

// Convertir secondes → hh:mm:ss
function formatHMS(sec) {
    if (sec < 0) return "—";
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = Math.floor(sec % 60);
    return `${h.toString().padStart(2,"0")}:${m.toString().padStart(2,"0")}:${s
        .toString()
        .padStart(2,"0")}`;
}

export default function Exploring() {
    const [merged, setMerged] = useState([]);
    const seen = useRef(new Set()); // mémorise les IDs déjà vus

    const loadData = async () => {
        try {
            const rawRes = await fetch(RAW_URL);
            const rawJson = await rawRes.json();

            const infoRes = await fetch(INFO_URL);
            const infoJson = await infoRes.json();

            const infoByBib = {};
            infoJson.forEach((r) => {
                infoByBib[r["Dossard"]] = r;
            });

            const arrivals = rawJson
                .filter((p) => p.TimingPoint.includes("arrivée"))
                .map((p) => {
                    const bib = p.Bib;
                    const info = infoByBib[bib] || {};

                    const timestamp = p.Time;
                    const officialCalc = timestamp - START_TIME;

                    const isNew = !seen.current.has(p.ID);
                    if (isNew) seen.current.add(p.ID);

                    return {
                        id: p.ID,
                        bib,
                        timestampRaw: timestamp,
                        timestampFormatted: formatTimestamp(timestamp),
                        officialCalcFormatted: formatRaceTime(officialCalc),
                        officialCalcHMS: formatHMS(officialCalc),
                        name: info["Nom Prénom"] || "",
                        year: info["Année"] || "",
                        officialRR: info["Temps"] || "",
                        isNew,
                    };
                })
                .sort((a, b) => b.timestampRaw - a.timestampRaw);

            setMerged(arrivals);
        } catch (err) {
            console.error("Erreur API", err);
        }
    };

    useEffect(() => {
        loadData();
        const interval = setInterval(loadData, 2000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={page}>
            <h1>Exploring — Derniers passages à l’arrivée</h1>

            <table style={table}>
                <thead>
                <tr>
                    <th style={th}>Dossard</th>
                    <th style={th}>Nom</th>
                    <th style={th}>Année</th>
                    <th style={th}>Timestamp réel</th>
                    <th style={th}>Temps officiel (mm:ss.xx)</th>
                    <th style={th}>Temps officiel (hh:mm:ss)</th>
                    <th style={th}>Temps RR</th>
                </tr>
                </thead>

                <tbody>
                {merged.map((m, i) => (
                    <tr
                        key={m.id}
                        style={{
                            ...tdRow,
                            ...(m.isNew ? highlight : {}),
                        }}
                    >
                        <td style={td}>{m.bib}</td>
                        <td style={td}>{m.name}</td>
                        <td style={td}>{m.year}</td>
                        <td style={td}>{m.timestampFormatted}</td>
                        <td style={td}>{m.officialCalcFormatted}</td>
                        <td style={td}>{m.officialCalcHMS}</td>
                        <td style={td}>{m.officialRR}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}

/* --- Styles --- */

const page = {
    padding: "40px",
    fontFamily: "Arial, sans-serif",
};

const table = {
    width: "100%",
    borderCollapse: "collapse",
};

const th = {
    borderBottom: "2px solid #ccc",
    textAlign: "left",
    padding: "10px",
};

const td = {
    padding: "10px",
    borderBottom: "1px solid #eee",
};

const tdRow = {
    transition: "background-color 0.8s ease",
};

const highlight = {
    backgroundColor: "rgba(0, 255, 0, 0.25)",
};
